import { render } from "./RegisterPage.vue?vue&type=template&id=3eb42dc7&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=3eb42dc7&scoped=true&lang=css"
import "./RegisterPage.vue?vue&type=style&index=1&id=3eb42dc7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb42dc7"]])

export default __exports__